var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDateYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.552734 5.61019C0.552734 4.11933 0.552734 3.37469 1.01596 2.91147C1.47919 2.44824 2.22382 2.44824 3.71468 2.44824H13.2005C14.6914 2.44824 15.436 2.44824 15.8993 2.91147C16.3625 3.37469 16.3625 4.11933 16.3625 5.61019C16.3625 5.98251 16.3625 6.16906 16.2471 6.28527C16.1309 6.40068 15.9435 6.40068 15.572 6.40068H1.34322C0.970902 6.40068 0.784347 6.40068 0.668145 6.28527C0.552734 6.16906 0.552734 5.98172 0.552734 5.61019ZM0.552734 12.7246C0.552734 14.2154 0.552734 14.9601 1.01596 15.4233C1.47919 15.8865 2.22382 15.8865 3.71468 15.8865H13.2005C14.6914 15.8865 15.436 15.8865 15.8993 15.4233C16.3625 14.9601 16.3625 14.2154 16.3625 12.7246V8.77214C16.3625 8.39982 16.3625 8.21326 16.2471 8.09706C16.1309 7.98165 15.9435 7.98165 15.572 7.98165H1.34322C0.970902 7.98165 0.784347 7.98165 0.668145 8.09706C0.552734 8.21326 0.552734 8.40061 0.552734 8.77214V12.7246Z",
    fill: "#FEC200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.50488 0.867188V3.23865M12.4098 0.867188V3.23865",
    stroke: "#FEC200",
    strokeWidth: 1.58097,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDateYellow);
export default __webpack_public_path__ + "static/media/iconDateYellow.0938b08aaae70e295cde4c0549166920.svg";
export { ForwardRef as ReactComponent };